import { useEffect, useRef, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useAtom } from 'jotai'
import { useOnboardingStatus } from 'src/hooks/useOnboardingStatus'
import { eaterProfileOnboardingModalAtom } from 'src/atoms/modals/eaterProfileOnboardingModal.atom'
import { EaterProfileOnboardingModal } from './components/EaterProfileOnboardingModal/EaterProfileOnboardingModal'
import { getProfilesStatus } from 'src/modules/MyPlan/selectors'
import { PreferencesPageContext } from './PreferencesPageContext'
import PreferencesPage from './PreferencesPage'

export function PreferencesPageWrapper(props) {
  const {
    refetch: refetchOnboardingStatus,
    onboardingStatus
  } = useOnboardingStatus()

  const eaterProfileStatusSaved = useRef<boolean | null>(null)
  const { succeeded } = useSelector(getProfilesStatus)
  const [{ isOpen }, setEaterProfileModal] = useAtom(
    eaterProfileOnboardingModalAtom
  )

  useEffect(() => {
    const eaterProfileStep = onboardingStatus?.find(
      step => step.name === 'eater_profile'
    )

    if (
      eaterProfileStep?.completed === true &&
      eaterProfileStatusSaved.current
    ) {
      setEaterProfileModal({ isOpen: true })
    }
  }, [onboardingStatus, setEaterProfileModal])

  useEffect(() => {
    if (succeeded) {
      refetchOnboardingStatus()
    }
  }, [succeeded, refetchOnboardingStatus])

  return (
    <>
      <PreferencesPageContext.Provider
        value={useMemo(
          () => ({
            updateEaterprofileStatus: () => {
              eaterProfileStatusSaved.current = true
            }
          }),
          []
        )}>
        <PreferencesPage {...props} />
      </PreferencesPageContext.Provider>
      {isOpen && <EaterProfileOnboardingModal />}
    </>
  )
}
